//External Libraries
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DISMISS_MS = 5000;

interface CommentWarningToastProps {
  message: string | null;
  onDismiss: () => void;
}

function CommentWarningToast({ message, onDismiss }: CommentWarningToastProps) {
  const { t } = useTranslation('common', { keyPrefix: 'auth' });

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onDismiss, DISMISS_MS);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  if (!message) return null;

  return (
    <div
      role="alert"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-lg bg-cm-charcoal-1 px-4 py-3 shadow-lg login-toast-enter"
      style={{ maxWidth: '360px' }}
    >
      <FontAwesomeIcon icon={faTriangleExclamation} className="shrink-0 text-amber-400" style={{ fontSize: '1.1rem' }} />
      <span className="flex-1 text-sm font-medium text-white">{message}</span>
      <button
        onClick={onDismiss}
        aria-label={t('close')}
        className="shrink-0 text-white/60 hover:text-white transition-colors"
        style={{ fontSize: '0.9rem', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
}

export default CommentWarningToast;
